export enum ColorName {
    Text,
    TextOutline,
    TextHover,
    TextHoverOutline,
    PanelBackground,
}

export const colorSwatch: Ss13Color = {
    Text: '#4d6a94',
    TextOutline: '#405578',
    TextHover: '#ffac7f',
    TextHoverOutline: '#f54f4f',
    PanelBackground: '#728794',
};

type Ss13Color = {
    [key in keyof typeof ColorName]: string;
};
